import React, { useEffect, useState } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import withRouter from '../.././components/withRouter';
import TableContainer from '../.././components/TableContainerReactTable';
import AddEditBlockedKeywordsModal from './AddEditBlockedKeywordsModal';
import { getBlockedKeywords } from '../../api/blockedKeywordsApi';
import { BlockedKeywords } from '../../types/blocked-keywords';
import { useProfile } from '../../hooks/UserHooks';

const Index = (props: any) => {
    const { userProfile } = useProfile();
    const [data, setData] = useState<BlockedKeywords[]>([]);
    const [dataToEdit, setDataToEdit] = useState<BlockedKeywords | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [isAddModalOpen, setIsAddModalOpen] = useState<boolean>(false);

    useEffect(() => {
        getBlockedKeywords().then((res) => {
            setData(res);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    const toggleAddEditModal = () => {
        setIsAddModalOpen(!isAddModalOpen);
    };

    const handleUpdateData = (newData: BlockedKeywords) => {
        const updatedData = data.map((item) => {
            if (item.id === newData.id) {
                return newData;
            }
            return item;
        });
        setData(updatedData);
    };

    const handleAddData = (newData: BlockedKeywords) => {
        setData([...data, newData]);
    };

    const dateFormatOptions: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZoneName: 'shortOffset',
    };

    const columns = [
        {
            header: '#',
            cell: (cell: any) => {
                return (
                    <span className="fw-semibold">{cell.getValue()}</span>
                );
            },
            accessorKey: 'id',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Nome',
            accessorKey: 'name',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Palavras',
            accessorFn: (row: any) => {
                return row.words.split('\n').length;
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Campanhas',
            accessorKey: 'campaigns.length',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Criado em',
            accessorFn: (row: any) => {
                const date = new Date(row.createdAt);
                return date.toLocaleDateString('pt-BR', dateFormatOptions);
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Atualizado em',
            accessorFn: (row: any) => {
                const date = new Date(row.updatedAt);
                return date.toLocaleDateString('pt-BR', dateFormatOptions);
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Actions',
            cell: (cell: any) => {
                const row = cell.row.original;
                let actionCell = [];

                // Botão de editar
                if (userProfile?.role === 'ROLE_SUPER_ADMIN') {
                    actionCell.push(<div key="action_edit">
                        <button className="btn text-primary d-inline-block"
                                id={'action_edit_' + row.id}
                                onClick={() => {
                                    setDataToEdit(row);
                                    toggleAddEditModal();
                                }}
                        ><i className="ri-pencil-fill fs-16"></i></button>
                        <UncontrolledTooltip
                            placement="top"
                            target={'action_edit_' + row.id}
                        >
                            Editar
                        </UncontrolledTooltip>
                    </div>);
                }

                return <div className="d-flex gap-2">{actionCell}</div>;
            },
            enableColumnFilter: false,
        },
    ];

    document.title = 'Palavras Chave Proteções | Ad Pulse';
    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row g-4 align-items-center">
                                        <div className="col-sm">
                                            <h5 className="card-title mb-0">Listas de palavras chave</h5>
                                        </div>
                                        <div className="col-sm-auto">
                                            {userProfile?.role === 'ROLE_SUPER_ADMIN' && (
                                                <button
                                                    type="button"
                                                    className="btn btn-success add-btn me-1"
                                                    id="create-btn"
                                                    onClick={() => {
                                                        setDataToEdit(null);
                                                        toggleAddEditModal();
                                                    }}
                                                >
                                                    <i className="ri-add-line align-bottom me-1"></i> Criar lista
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    {!loading ? <TableContainer
                                            divClass="table-responsive"
                                            columns={(columns || [])}
                                            data={(data || [])}
                                            isGlobalFilter={true}
                                            customPageSize={30}
                                            SearchPlaceholder="Procurar..."
                                        /> :
                                        <div className="text-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Carregando...</span>
                                            </div>
                                        </div>}

                                    {userProfile?.role === 'ROLE_SUPER_ADMIN' && (
                                        <AddEditBlockedKeywordsModal
                                            blockedKeywords={dataToEdit}
                                            isOpen={isAddModalOpen}
                                            toggle={toggleAddEditModal}
                                            onAddData={handleAddData}
                                            onUpdateData={handleUpdateData}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default withRouter(Index);